import { createLucideIcon } from "lucide-react";

export const MinusCircle = createLucideIcon(
    "MinusCircle",
    [
        [
            "path",
            {
                d: "M16 12H8",
                key: "1fr5h0",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
